import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconHelp.module.css';

const IconHelp = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1155 13.0658C11.0977 13.3041 11.0894 13.5934 11.0894 13.936L12.9412 13.9395C12.9412 13.7404 12.9459 13.5709 12.9554 13.4298C12.9638 13.2974 12.9877 13.1666 13.0265 13.0398C13.0669 12.9142 13.1282 12.7964 13.2079 12.6912C13.3167 12.5512 13.4356 12.4193 13.5635 12.2965C13.8066 12.0843 14.0508 11.8649 14.2879 11.6397C14.5219 11.4213 14.7368 11.1833 14.9304 10.9284C15.1183 10.6795 15.2733 10.4073 15.3916 10.1187C15.5131 9.81255 15.5736 9.48552 15.5694 9.15611C15.5779 8.72575 15.4972 8.2983 15.3323 7.90069C15.1793 7.54654 14.9435 7.23431 14.6447 6.99023C14.319 6.73146 13.9432 6.54296 13.541 6.43661C13.0593 6.30639 12.5617 6.24375 12.0627 6.25049C11.6004 6.24649 11.1398 6.30796 10.6947 6.43306C10.2954 6.54326 9.92192 6.73142 9.59573 6.98668C9.28067 7.23705 9.02653 7.55565 8.85243 7.91847C8.66041 8.33149 8.56397 8.78248 8.57028 9.23791H10.639C10.637 9.03314 10.6812 8.83055 10.7682 8.64517C10.8439 8.48921 10.9532 8.35197 11.0883 8.24329C11.2212 8.13827 11.374 8.06125 11.5376 8.01686C11.7069 7.96928 11.8821 7.94535 12.058 7.94573C12.4397 7.9179 12.8187 8.02906 13.1249 8.2587C13.2548 8.38615 13.3549 8.54082 13.4178 8.71158C13.4807 8.88234 13.505 9.06494 13.4889 9.24621C13.4876 9.44148 13.4447 9.63424 13.3632 9.81169C13.2741 10.0081 13.1631 10.1938 13.0324 10.3653C12.8916 10.5509 12.7387 10.7271 12.5748 10.8928C12.4065 11.0643 12.2382 11.2264 12.0698 11.3789C11.8691 11.5304 11.6858 11.7038 11.5233 11.8958C11.3968 12.0533 11.2989 12.2319 11.2341 12.4233C11.1676 12.6316 11.1277 12.8475 11.1155 13.0658Z"
        fill="currentColor"
      />
      <path
        d="M10.8666 15.7308C10.8112 15.8768 10.7835 16.0317 10.7848 16.1878C10.7835 16.3404 10.8113 16.4919 10.8666 16.6341C10.9185 16.7687 10.9995 16.8901 11.1037 16.9898C11.2131 17.0933 11.3421 17.1739 11.483 17.2269C11.8089 17.3407 12.1637 17.3407 12.4895 17.2269C12.6318 17.1744 12.762 17.0938 12.8724 16.9898C12.9756 16.8893 13.0564 16.7681 13.1095 16.6341C13.167 16.4926 13.196 16.3412 13.1949 16.1884C13.1962 16.0318 13.1672 15.8764 13.1095 15.7308C13.0561 15.5935 12.9755 15.4685 12.8724 15.3633C12.7633 15.2577 12.6327 15.1768 12.4895 15.1262C12.1637 15.0124 11.8089 15.0124 11.483 15.1262C11.3412 15.1775 11.2119 15.2584 11.1037 15.3633C10.9996 15.4677 10.9188 15.5929 10.8666 15.7308Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
};

IconHelp.defaultProps = { className: null };

IconHelp.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconHelp;
